import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { EnaioCertificateService } from 'src/modules/enaio-certificates/services/enaio-certificate.service';
import { EnaioCertificatesTools } from 'src/modules/enaio-certificates/shared/enaio-certificates-tools';
import { SchoolClass } from 'src/modules/enaio-certificates/shared/school-class.model';
import { SchoolType } from 'src/modules/enaio-certificates/shared/school-type.enum';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'app-grade-book-main',
    templateUrl: './grade-book-main.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GradeBookMainComponent extends ComponentView {

    _SchoolType = SchoolType;

    service = inject(EnaioCertificateService);

    neededParams: ObjectOfSimpleDataTypes = { year: "number?" };
    year: number;

    schoolClasses: SchoolClass[] = [];
    years: number[];
    isHalfYear: boolean;
    userName = "";
    isAdmin = false;

    async initParams(): Promise<boolean> {
        this.fullScreenComponent = false;
        this.isHalfYear = EnaioCertificatesTools.getCurrentIsHalfYear();
        this.years = Arrays.reverse(Utils.getRange(2021, EnaioCertificatesTools.getCurrentYear()));
        this.isAdmin = this.service.isAdminForCertificates();
        this.userName = this.app.getUserName();
        this.year = Utils.toNumber(this.year ?? EnaioCertificatesTools.getCurrentYear());
        this.app.updateNavigation("Notenbuch", [this.service.getHomeGradeBook()]);
        this.schoolClasses = (await this.service.restGetSchoolClasses(EnaioCertificatesTools.getSchoolYearFromYear(this.year))).filter(sc => sc.isForGradeBook());
        return true;
    }

    getExistingGrades(): number[] {
        return Arrays.getUnique(this.schoolClasses.map(sc => sc.grade));
    }

    async adminClick(): Promise<void> {
        await this.app.navigateTo(["/enaio-certificates", "globalsettings"]);
    }

    async selectedYearChanged(): Promise<void> {
        await this.app.navigateTo(["/enaio-certificates", "grade-book", "home", this.year]);
    }

}
